import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { Controller, useWatch } from 'react-hook-form';
import { useDebounce } from 'rooks';
import { Autocomplete } from 'enova-frontend-components';

import { useKommuneSearch } from '../useKommuneSearch';
import { useAdvancedSearchFormContext } from '../../types';

export const KommuneField = () => {
  const { t } = useTranslation();
  const [kommunenavn, setKommunenavn] = useState();

  const { control, getValues } = useAdvancedSearchFormContext();

  const { isLoading } = useKommuneSearch(kommunenavn || getValues().kommunenummer?.toString() || '');
  const options = useWatch({ control, name: 'kommuneOptions' });
  const postnummer = useWatch({ control, name: 'postnummer' });
  const setKommunenavnDebounced = useDebounce(setKommunenavn, 500);

  return (
    <Controller
      control={control}
      name="kommunenummer"
      rules={{
        validate: {
          required: (value) => {
            const errorMessage = t('search.advanced.error.postnummerOrKommunenummer') as string;

            // Ensure that kommune is required if postnummer is provided
            if (!value && postnummer) {
              return errorMessage;
            }
            // If both kommune and postnummer is empty
            if (!value && !postnummer) {
              return errorMessage;
            }

            return true;
          }
        }
      }}
      render={({ field: { onChange, value, ...rest }, fieldState }) => {
        return (
          <Autocomplete
            value={value}
            label={t('search.advanced.field_kommunenavn')}
            onChange={(_, option) => {
              onChange(option?.value ?? '');
            }}
            onInputChange={(_, val, reason) => {
              if (reason === 'input') {
                setKommunenavnDebounced(val);
              }
            }}
            fullWidth
            error={!!fieldState.error}
            loading={isLoading}
            disabled={!!postnummer}
            options={options}
            loadingText={t('search.advanced.kommune.loading')}
            noOptionsText={t('search.advanced.kommune.noOptions')}
            {...rest}
          />
        );
      }}
    />
  );
};
